import { PostAuthenticationDto } from "../dto/post-authentication-dto";
import { PostAuthenticationModel } from "../../models/post-authentication-model";

export class PostAuthenticationConverter {

  static convert(dto: PostAuthenticationDto): PostAuthenticationModel {
    return new PostAuthenticationModel(
      dto.statusCode,
      dto.userMessageTitle,
      dto.userMessageDesc,
      dto.data.retry
    );
  }

}